<template>
  <v-ons-page>
    <div class="sticky1">
      <v-ons-list>
        <v-ons-list-item style="font-size: 0.8em">
          <div class="center">
          </div>
          <div class="right">
            <v-ons-button @click="showPopover($event, 'left', coverTarget, help.about)" modifier="quiet" style="align-self: flex-start">
              <v-ons-icon icon="fa-question-circle"></v-ons-icon></v-ons-button>
          </div>
        </v-ons-list-item>
      </v-ons-list>
    </div>

    <div class="bodycontent">
      <!-- ユーザ情報に関する項目 -->
      <v-ons-list>
        <v-ons-list-header>登録済みメールアドレス</v-ons-list-header>
        <v-ons-list-item modifier="nodivider">
          <!-- <div class="left"><v-ons-icon fixed-width icon="fa-user"></v-ons-icon></div> -->
          <div class="left"><span style="font-size: 0.7em;">Email：　</span></div>
          <div class="center"><span style="font-size: 0.9em;">{{account.email}}</span></div>
          <div class="right">
            <v-ons-button modifier="quiet" @click="goTo(editUser)"><v-ons-icon icon="fa-edit"></v-ons-icon></v-ons-button>
          </div>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider"></v-ons-list-item>

        <v-ons-list-header>SNSアカウント連携
          <v-ons-button modifier="quiet" @click="goTo(oAuth)"><v-ons-icon icon="fa-edit"></v-ons-icon></v-ons-button>
        </v-ons-list-header>
        <!-- <div v-if="twitterAuth"> -->
        <div v-if="twitterAuth !== null">
          <v-ons-list-item modifier="nodivider">
            <div class="left"><v-ons-icon icon="fa-twitter" style="color: #1da1f2;"></v-ons-icon></div>
            <div class="center"><span style="font-size: 0.9em;">{{twitterAuth.profileName}}@{{twitterAuth.profileScreenName}}</span></div>
            <div class="right">
              <v-ons-button modifier="quiet" @click="delTwitterAuth(twitterAuth)"><v-ons-icon icon="fa-minus-circle"></v-ons-icon></v-ons-button>
            </div>
          </v-ons-list-item>
        </div>
        <!-- <div v-else> -->
        <div v-show="twitterAuth === null">
          <v-ons-list-item modifier="nodivider">
            <div class="center"><span style="font-size: 0.9em;">連携しているアカウントはありません。</span></div>
          </v-ons-list-item>
        </div>

        <div v-if="isLicReady">
          <v-ons-list-header>現在のライセンス</v-ons-list-header>
          <v-ons-list-item modifier="nodivider">
            <div class="left"><span style="color: gray; font-size: 0.8em;">種別</span></div>
            <div class="center">
              {{lic.role | filterLicenseType}}
            </div>
            <div class="right">
              <v-ons-button @click="dialogPlanDetail = true">内容</v-ons-button>
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider">
            <div class="left"><span style="color: gray; font-size: 0.8em;">有効期間</span></div>
            <div class="center">
              {{lic.expiredAt | filterLicenseExpiration}}
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider" v-show="lic.role !== 'free'">
            <div class="left"><span style="color: gray; font-size: 0.8em;">継続設定</span></div>
            <div class="center">
              <span v-if="lic.status === 'active'">
                {{lic.recursive | filterLicenseRecursive}}
              </span>
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <span style="font-size: 0.8em;">
                トリガー型：{{lic.triggered}}/{{triggeredCap}}<br>
                送信日指定：{{lic.scheduled}}/{{scheduledCap}}<br>
                　　　動画：{{lic.movie}}/{{movieCap}}
              </span>
            </div>
          </v-ons-list-item>
          <v-ons-list-item>
            <div class="center" modifier="nodivider" style="font-size: 0.8em;">
              <span v-if="(lic.status === 'canceled')" style="color: tomato;">
                <v-ons-icon icon="fa-exclamation-circle">　ライセンスが解約されている為、利用制限が発生します。再びご利用になるにはライセンスの購入をお願いします。</v-ons-icon>
              </span>
              <span v-else-if="(lic.status !== 'active') && (lic.status !== 'canceled') && (lic.status !== 'free')" style="color: tomato;">
                <v-ons-icon icon="fa-exclamation-circle">　購入処理が完了していません。<br>　　購入履歴からご確認ください。</v-ons-icon>
              </span>
              <span v-else-if="(!isValidDue)" style="color: tomato;">
                <v-ons-icon icon="fa-exclamation-circle">　有効期間終了のため、利用制限が発生します。<br>　　ライセンスの購入をお願いします。</v-ons-icon>
              </span>
              <span v-else-if="(lic.recursive === true)" style="color: orange;">
                <span v-show="lic.role !== 'free'">
                  <v-ons-icon icon="fa-exclamation-circle">　有効期間終了後は利用制限が発生します。<br>　　購入履歴から自動継続を有効にしてください。</v-ons-icon>
                </span>
                <span v-show="lic.role === 'free'">
                  <v-ons-icon icon="fa-exclamation-circle">　有効期間終了後は利用制限が発生します。<br>　　ライセンスの購入をお願いします。</v-ons-icon>
                </span>
              </span>
            </div>
          </v-ons-list-item>
          <v-ons-list-item>
            <v-ons-button modifier="large" @click="goToPurchase()"><v-ons-icon icon="fa-shopping-cart">　ライセンス購入画面へ</v-ons-icon></v-ons-button>
          </v-ons-list-item>
        </div>
      
      </v-ons-list>
    </div>

    <v-ons-dialog :visible.sync="dialogPlanDetail">
      <div class="dialogview2">
        <v-ons-button class="closebutton" modifier="quiet" @click="dialogPlanDetail = false"><v-ons-icon icon="fa-window-close"></v-ons-icon></v-ons-button>
        <v-ons-card v-if="isLicReady">
          <div class="content">
            <v-ons-list>
              <v-ons-list-item modifier="nodivider">
                <div v-if="lic.role === 'free'">
                  <table border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#333333">
                    <tr>
                      <th width="30%" align="center">無料プラン</th>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="naiyou">アカウント登録後にはデフォルトで無料プランとなります。まずは基本機能を試してみましょう。期間終了までに他のプランへの乗り換えをご検討ください。</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">期間：</span><span class="naiyou">90日間</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">メッセージ数：</span><br>
                                                  <span class="naiyou">トリガー型 x 2</span><br>
                                                  <span class="naiyou">送信日指定 x 2</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">動画数：</span><span class="naiyou">0</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">送信日指定範囲：</span><span class="naiyou">登録日から90日</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">有効期間終了後のトリガー型メッセージ：</span><br><span class="naiyou">リマインダー停止<br>メッセージは送られません。</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">価格：</span><span>0円</span></td>
                    </tr>
                  </table>
                </div>
                <div v-else-if="lic.role === 'basic'">
                  <table border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#333333">
                    <tr>
                      <th width="30%" align="center"><img src="../assets/BasicPass.png" width="120" height="120"></th>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="naiyou">1年ごとに更新するプランです。メッセージ数がそれほど多く必要ではない方に向いています。送信日指定はプランの有効期間内までしか指定できません。プランの更新を行わずに有効期間切れになった場合には、お預かりしているメッセージが送信されませんので注意が必要です。</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">期間：</span><span class="naiyou">１年間</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">メッセージ数：</span><br>
                                                  <span class="naiyou">トリガー型 x 10</span><br>
                                                  <span class="naiyou">送信日指定 x 10</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">動画数：</span><span class="naiyou">0</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">送信日指定範囲：</span><span class="naiyou">購入日から１年</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">有効期間終了後のトリガー型メッセージ：</span><br><span class="naiyou">リマインダー停止<br>メッセージは送られません。</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">価格：</span><span>1980円</span></td>
                    </tr>
                  </table>
                </div>
                <div v-else-if="lic.role === 'premium'">
                  <table border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#333333">
                    <tr>
                      <th width="30%" align="center"><img src="../assets/Premium.png" width="120" height="120"></th>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="naiyou">1年ごとに更新するプランですが、有効期限切れになった場合でもお預かりしているメッセージのリマインダー、送信日指定メッセージは継続動作します。送信日指定にも未来の日付に制限はありません。動画ファイルをメッセージに添付することも可能です。有効期限切れの場合には、新規メッセージの追加と編集が行えなくなりますが、実質的に１年間払い切りでその後もサービスが続く限りメッセージのお預かりを行うプランです。</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">期間：</span><span class="naiyou">１年間</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">メッセージ数：</span><br>
                                                  <span class="naiyou">トリガー型 x 30</span><br>
                                                  <span class="naiyou">送信日指定 x 30</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">動画数：</span><span class="naiyou">3</span><br><span class="naiyou">(512MB以下 x 3)</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">送信日指定範囲：</span><span class="naiyou">無制限</span><br><span class="naiyou">20年先でも設定可</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">有効期間終了後のトリガー型メッセージ：</span><br><span class="naiyou">リマインダー継続<br>有効期間後も動作します。</span></td>
                    </tr>
                    <tr style="font-size: 0.8em;">
                      <td valign="top" width="30%"><span class="koumoku">価格：</span><span>5980円</span></td>
                    </tr>
                  </table>
                </div>
              </v-ons-list-item>
            </v-ons-list>
          </div>
        </v-ons-card>
      </div>
    </v-ons-dialog>

    <v-ons-popover cancelable
      :visible.sync="popoverVisible"
      :target="popoverTarget"
      :direction="popoverDirection"
      :cover-target="coverTarget"
    >
    <p class="helpmessage">{{helpMessage}}</p>
    </v-ons-popover>

  </v-ons-page>
</template>

<script>
// import firebase from 'firebase'
import common from '../util/common'
import comHelp from '../util/com_help'
import comTw from '../util/com_twitter'
import comLic from '../util/com_license'

export default {
  name: 'AccountRoot',
  mixins: [common, comHelp, comTw, comLic],
  data () {
    return {
      msg: 'アカウント',
      editUser: {
        link: 'AccountEdit',
        anim: 'slide'
      },
      oAuth: {
        link: 'OpenAuth',
        anim: 'slide'
      },
      Purchase: {
        link: 'PurchaseLicense',
        anim: 'slide'
      },
      isUserRegistered: false,
      help: {
        about: 'アカウント情報ページです。\n\r'
      },
      dialogPlanDetail: false
    }
  },

  async created () {
    // console.log('Created AccountRoot')
    await this.getLicense()
    await this.getTwitterAuth()
    this.checkExpiration(this.lic)
    this.getCaps()
  },

  mounted () {
    // console.log('Mounted AccountRoot')
  },

  computed: {
  },

  methods: {
    goToPurchase () {
      this.$store.commit('routerAnim/set', 'slide')
      this.$router.push({name: 'PurchaseLicense', params: {from: 'AccountRoot'}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../src/assets/css/miley.css";
</style>



// WEBPACK FOOTER //
// src/components/AccountRoot.vue